import styled from 'styled-components';
import colors from '../../../../../../../constants/js/colors.js';
import border from '../../../../../../../constants/js/border.js';
import { constantColorBg, constantColorBorder } from './constants';
export const StyledContainer = styled.div.withConfig({
  componentId: "InputContainer__sc-14k9onb-0"
})(["display:flex;align-items:center;border:1px solid ", ";border-radius:", ";background:", ";border:1px solid ", ";&:focus-within,&:focus-within:hover{border-color:", ";background:", ";}", ""], colors.majorGray, border.borderRadius, ({
  status
}) => constantColorBg[status || 'base'], ({
  status
}) => constantColorBorder[status || 'base'].base, ({
  status
}) => constantColorBorder[status || 'base'].focus, constantColorBg.base, ({
  status,
  isDisabled
}) => !isDisabled && `
		&:hover {
			border-color: ${constantColorBorder[status || 'base'].hover};
		}
	`);